$(document).ready(() =>
{

    const core = Minus40Core.getInstance();
    const request = Minus40Request.getInstance();

    /*
        basic premise is that when any dropdown filter is clicked
            we close all cards
            then for each card, go through each currently filter and see it matches them all
            open it if so.
        it's flexible in that it works with anything from 1 to N filter groups at once.
    */


    class Property {
        /** @type {HTMLElement} */
        card;
        /** @type {HTMLElement} */
        parentElement;
        /** @type {HTMLElement} */
        mapMarker;
        active = false;
        postID = 0;
        sizeSquareFeetFrom = 0;
        sizeSquareFeetTo = 0;
        siblingCard = "";
        latitude = 0;
        longitude = 0;
        town = "";
        county = "";
        postcodeRegion = "";
        propertyStatus = "";
        epc = "";
        price = 0;
        rentPerMonthFrom = 0;
        rentPerMonthTo = 0;
        rentPerSquareFootFrom = 0;
        rentPerSquareFootTo = 0;
        /** @type {Date|null} */
        postDate = null;
        /** @type {Date|null} */
        sourceUpdatedAt = null;
        availabilityStatus = [];
        saleLetStatus = [];
        category = [];

        distanceInMetres = 0;

        /**
         *
         * @param card {HTMLElement}
         * @param postID {number}
         */
        constructor(card, postID) {
            this.card = card;
            this.parentElement = card.parentElement;
            this.postID = postID;
        }
    }

    class FilterViewController {

        /** @type {HTMLElement} */
        filterViewSection;
        /** @type {HTMLAnchorElement} */
        toggleFilters;
        /** @type {HTMLElement} */
        searchContainer;
        /** @type {HTMLElement} */
        sortContainer;
        /** @type {NodeListOf<HTMLElement>} */
        dropdownMenus;
        /** @type {HTMLElement} */
        listingsLoading;
        /** @type {HTMLElement} */
        listingsGroupContainer;
        /** @type {HTMLElement} */
        listingsGroup;
        /** @type {HTMLElement} */
        listingsErrorContainer;
        /** @type {HTMLElement} */
        listingsErrorText;
        /** @type {HTMLElement|null} */
        filtersColumn;
        /** @type {HTMLElement|null} */
        rangesColumn;
        /** @type {HTMLElement|null} */
        pageCounterResultsContainer;
        /** @type {HTMLElement|null} */
        pageCounterResults;
        /** @type {HTMLElement|null} */
        resultsForLocation;
        /** @type {HTMLElement|null} */
        noResults;
        /** @type {HTMLElement|null} */
        fromLocationMessage;
        /** @type {HTMLElement|null} */
        fromLocationValue;
        /** @type {HTMLElement[]} */
        dropdownMenuParents;
        /** @type {HTMLInputElement|null} */
        maxPriceContainerElement;
        /** @type {HTMLInputElement|null} */
        maxRentPerMonthContainerElement;
        /** @type {HTMLInputElement|null} */
        maxRentPerSquareFootContainerElement;
        /** @type {HTMLInputElement|null} */
        maxPriceElement;
        /** @type {HTMLInputElement|null} */
        maxRentPerMonthElement;
        /** @type {HTMLInputElement|null} */
        maxRentPerSquareFootElement;
        /** @type {HTMLInputElement|null} */
        maxSizeSquareFeetElement;
        /** @type {HTMLInputElement|null} */
        maxPriceDisplayElement;
        /** @type {HTMLInputElement|null} */
        maxRentPerMonthDisplayElement;
        /** @type {HTMLInputElement|null} */
        maxRentPerSquareFootDisplayElement;
        /** @type {HTMLInputElement|null} */
        maxSizeSquareFeetDisplayElement;
        /** @type {HTMLButtonElement|null} */
        sizeSquareFeetSearchButton;
        /** @type {HTMLInputElement|null} */
        sizeSquareFeetSearchText;
        /** @type {HTMLSelectElement|null} */
        sizeSquareFeetSearchRadius;
        /** @type {HTMLButtonElement|null} */
        buttonMapPrevious;
        /** @type {HTMLButtonElement|null} */
        buttonMapNext;
        /** @type {HTMLButtonElement|null} */
        buttonSortByDistance;
        /** @type {HTMLButtonElement|null} */
        buttonSortByPrice;
        /** @type {HTMLButtonElement|null} */
        buttonSortByDate;
        /** @type {HTMLElement|null} */
        rentSortPreferenceContainer;
        /** @type {Property[]} */
        allPropertyList = [];
        /** @type {Property[]} */
        currentPropertyList = [];

        previousSearches = {};
        dropdownMenuOptions = {};
        restrictedToValuesDropdownMenuIDs = [];

        /** @type {MapLibreMap|null} */
        map = null;

        latitude = 0;
        longitude = 0;
        searchInputIsRequired = false;

        /** @type {string[]} */
        sortOrder = [];

        /** @type {string[]} */
        priceSortOptions = [];
        currentPriceSortOption = "price";

        /**
         *
         * @param {HTMLElement} filterViewSection
         */
        constructor(filterViewSection) {

            this.filterViewSection = filterViewSection;
            const osmMap = filterViewSection.querySelectorAll('.osm-map.populate')[0] ?? null;
            this.map = osmMap?.id ? OSM.Maps[osmMap.id] : null;
            this.searchContainer = filterViewSection.querySelectorAll('#searchContainer')[0] ?? null;
            this.sortContainer = filterViewSection.querySelectorAll('#sortContainer')[0] ?? null;
            this.dropdownMenus = this.searchContainer?.querySelectorAll('.stay-on-page-dropdown-menu') ?? [];
            const dropdownMenuParents = [];
            for(let dropdownMenu of this.dropdownMenus){
                const parent = dropdownMenu.closest(".col");
                dropdownMenuParents.push(parent ? parent : dropdownMenu.parentNode);
            }
            this.dropdownMenuParents = dropdownMenuParents;
            this.listingsLoading = filterViewSection.querySelectorAll('#listingsLoading')[0] ?? null;
            this.listingsGroupContainer = filterViewSection.querySelectorAll('#listingsGroupContainer')[0] ?? null;
            this.listingsGroup = this.listingsGroupContainer?.querySelectorAll('.listings-group')[0] ?? null;
            this.listingsErrorContainer = filterViewSection.querySelectorAll('#listingsErrorContainer')[0] ?? null;
            this.listingsErrorText = this.listingsErrorContainer?.querySelectorAll('#listingsErrorText')[0] ?? null;
            if(!this.searchContainer || !this.listingsGroup || !this.listingsErrorText){
                return;
            }
            this.toggleFilters = filterViewSection.querySelectorAll('#toggleFilters')[0] ?? null;
            this.searchInputIsRequired = !!this.searchContainer.dataset.searchInputIsRequired;

            this.filtersColumn = filterViewSection.querySelectorAll('#filtersColumn')[0] ?? null;
            this.rangesColumn = filterViewSection.querySelectorAll('#rangesColumn')[0] ?? null;

            this.pageCounterResultsContainer = filterViewSection.querySelectorAll('#page-counter-results-container')[0] ?? null;
            this.pageCounterResults = this.pageCounterResultsContainer?.querySelectorAll('#page-counter-results')[0] ?? null;
            this.resultsForLocation = this.pageCounterResultsContainer?.querySelectorAll('#results-for-location')[0] ?? null;
            this.noResults = filterViewSection.querySelectorAll('#no-results')[0] ?? null;
            this.fromLocationMessage = filterViewSection.querySelectorAll('#fromLocationMessage')[0] ?? null;
            this.fromLocationValue = filterViewSection.querySelectorAll('.from-location-value')[0] ?? null;


            const cards = this.listingsGroup.querySelectorAll('.col');

            for(let card of cards){
                const postID = parseInt(card.dataset.postId ?? "0");
                if(postID){
                    const sizeSquareFeetFrom = parseInt(card.dataset.sizeSquareFeetFrom ?? "0");
                    const sizeSquareFeetTo = parseInt(card.dataset.sizeSquareFeetTo ?? "0");
                    const latitude = parseFloat(card.dataset.lat ?? "0");
                    const longitude = parseFloat(card.dataset.lng ?? "0");
                    const price = parseFloat(card.dataset.price ?? "0");
                    const rentPerMonthFrom = parseFloat(card.dataset.rentPerMonthFrom ?? "0");
                    const rentPerMonthTo = parseFloat(card.dataset.rentPerMonthTo?? "0");
                    const rentPerSquareFootFrom = parseFloat(card.dataset.rentPerSquareFootFrom ?? "0");
                    const rentPerSquareFootTo = parseFloat(card.dataset.rentPerSquareFootTo ?? "0");
                    const property = new Property(card, postID);
                    const saleOrLetStatuses = (card.dataset.saleOrLetStatuses ?? "").split(",");
                    for(let i = 0; i < saleOrLetStatuses.length; i++){
                        saleOrLetStatuses[i] = saleOrLetStatuses[i].trim();
                    }
                    const availabilityStatus = (card.dataset.availabilityStatus ?? "");
                    const categories = (card.dataset.category ?? "").split(",");
                    for(let i = 0; i < categories.length; i++){
                        categories[i] = categories[i].trim();
                    }

                    property.sizeSquareFeetFrom = sizeSquareFeetFrom ? sizeSquareFeetFrom: 0;
                    property.sizeSquareFeetTo = sizeSquareFeetTo ? sizeSquareFeetTo: 0;
                    property.siblingCard = card.dataset.siblingCard ?? "";
                    property.latitude = latitude ? latitude : 0;
                    property.longitude = longitude ? longitude : 0;
                    property.town = card.dataset.town ?? "";
                    property.county = card.dataset.county ?? "";
                    property.postcodeRegion = card.dataset.postcodeRegion ?? "";
                    property.propertyStatus = card.dataset.propertyStatus ?? "";
                    property.epc = card.dataset.epc ?? "";
                    property.price = price ? price : 0;
                    property.rentPerMonthFrom = rentPerMonthFrom ? rentPerMonthFrom : 0;
                    property.rentPerMonthTo = rentPerMonthTo ? rentPerMonthTo : 0;
                    property.rentPerSquareFootFrom = rentPerSquareFootFrom ? rentPerSquareFootFrom : 0;
                    property.rentPerSquareFootTo = rentPerSquareFootTo ? rentPerSquareFootTo : 0;
                    property.postDate = card.dataset.postDate ? core.timestampToDate(card.dataset.postDate) : null;
                    property.sourceUpdatedAt = card.dataset.postDate ? core.timestampToDate(card.dataset.sourceUpdatedAt) : null;
                    property.saleLetStatus = saleOrLetStatuses;
                    property.availabilityStatus = availabilityStatus;
                    property.category = categories;
                    if(osmMap){
                        property.mapMarker = osmMap.querySelectorAll(".marker[data-id='"+postID+"']")[0] ?? null;
                    }
                    this.allPropertyList.push(property);

                    if(property.price && !this.priceSortOptions.includes("price")){
                        this.priceSortOptions.push("price");
                    }
                    if(property.rentPerMonthFrom && !this.priceSortOptions.includes("rentPerMonth")){
                        this.priceSortOptions.push("rentPerMonth");
                    }
                    if(property.rentPerSquareFootFrom && !this.priceSortOptions.includes("rentPerSquareFoot")){
                        this.priceSortOptions.push("rentPerSquareFoot");
                    }
                }
                card.remove();
            }
            if(!this.priceSortOptions.length){
                this.priceSortOptions.push("price");
            }
            this.maxPriceContainerElement = this.searchContainer.querySelectorAll('#rangePriceContainer')[0] ?? null;
            this.maxPriceElement = this.searchContainer.querySelectorAll('#rangePrice')[0] ?? null;
            this.maxPriceDisplayElement = this.searchContainer.querySelectorAll("#rangePriceValue")[0] ?? null;
            this.maxRentPerMonthContainerElement = this.searchContainer.querySelectorAll('#rangeRentPerMonthContainer')[0] ?? null;
            this.maxRentPerMonthElement = this.searchContainer.querySelectorAll('#rangeRentPerMonth')[0] ?? null;
            this.maxRentPerMonthDisplayElement = this.searchContainer.querySelectorAll("#rangeRentPerMonthValue")[0] ?? null;
            this.maxRentPerSquareFootContainerElement = this.searchContainer.querySelectorAll('#rangeRentPerSquareFootContainer')[0] ?? null;
            this.maxRentPerSquareFootElement = this.searchContainer.querySelectorAll('#rangeRentPerSquareFoot')[0] ?? null;
            this.maxRentPerSquareFootDisplayElement = this.searchContainer.querySelectorAll("#rangeRentPerSquareFootValue")[0] ?? null;
            this.maxSizeSquareFeetElement = this.searchContainer.querySelectorAll('#rangeSizeSquareFeet')[0] ?? null;
            this.maxSizeSquareFeetDisplayElement = this.searchContainer.querySelectorAll("#rangeSizeSquareFeetValue")[0] ?? null;

            this.sizeSquareFeetSearchButton = this.searchContainer.querySelectorAll("#button_search")[0] ?? null;
            this.sizeSquareFeetSearchText = this.searchContainer.querySelectorAll("#text_search")[0] ?? null;
            this.sizeSquareFeetSearchRadius = this.searchContainer.querySelectorAll("#search_radius")[0] ?? null;
            if(!this.sizeSquareFeetSearchButton || !this.sizeSquareFeetSearchText || !this.sizeSquareFeetSearchRadius){
                return;
            }
            this.buttonMapPrevious = filterViewSection.querySelectorAll("#button_map_previous")[0] ?? null;
            this.buttonMapNext = filterViewSection.querySelectorAll("#button_map_next")[0] ?? null;
            this.buttonSortByDistance = this.sortContainer.querySelectorAll("#buttonSortByDistance")[0] ?? null;
            this.buttonSortByPrice = this.sortContainer.querySelectorAll("#buttonSortByPrice")[0] ?? null;
            this.buttonSortByDate = this.sortContainer.querySelectorAll("#buttonSortByDate")[0] ?? null;
            this.rentSortPreferenceContainer = filterViewSection.querySelectorAll("#rentSortPreferenceContainer")[0] ?? null;


            this.initDropdownMenus();
            this.initRanges();
            this.initSizeSquareFeetSearch();
            this.initPropertyList();
            this.initAdditionalButtons();
            this.initMapButtons();
            this.initPriceSortOptions();
        }

        onLocationRequested(){
            this.listingsErrorContainer.classList.add('d-none');
            this.searchContainer.classList.add('pe-none');
            this.searchContainer.classList.add('opacity-75');
            if(this.pageCounterResultsContainer){
                this.pageCounterResultsContainer.classList.add('invisible');
            }
            if(this.listingsLoading){
                this.listingsLoading.classList.remove('d-none');
            }
            this.listingsGroupContainer.classList.add('d-none');
        }

        onLocationError(errorText){
            this.searchContainer.classList.remove('pe-none');
            this.searchContainer.classList.remove('opacity-75');
            if(this.listingsLoading){
                this.listingsLoading.classList.add('d-none');
            }
            this.listingsErrorContainer.classList.remove('d-none');
            this.listingsErrorText.textContent = errorText;

            if(this.buttonSortByDistance){
                this.buttonSortByDistance.classList.add('disabled');
            }
            if(this.searchInputIsRequired){
                const initializedClass = this.searchContainer.dataset.initializedClass ?? "";
                if(initializedClass){
                    this.searchContainer.classList.remove(initializedClass);
                }
                if(this.filtersColumn){
                    this.filtersColumn.classList.add('d-none');
                }
                if(this.rangesColumn){
                    this.rangesColumn.classList.add('d-none');
                }
                if(this.buttonSortByPrice){
                    this.buttonSortByPrice.classList.add('d-none');
                }
            }
            if(this.fromLocationMessage){
                this.fromLocationMessage.classList.add('d-none');
            }
        }

        /**
         *
         * @param haveLocation {boolean=}
         */
        onLocationReceived(haveLocation){
            this.searchContainer.classList.remove('pe-none');
            this.searchContainer.classList.remove('opacity-75');
            if(this.pageCounterResultsContainer){
                this.pageCounterResultsContainer.classList.remove('invisible');
            }
            if(this.listingsLoading){
                this.listingsLoading.classList.add('d-none');
            }
            this.listingsGroupContainer.classList.remove('d-none');

            const initializedClass = this.searchContainer.dataset.initializedClass ?? "";
            if(initializedClass){
                this.searchContainer.classList.add(initializedClass);
            }
            if(this.filtersColumn){
                this.filtersColumn.classList.remove('d-none');
            }
            if(this.rangesColumn){
                this.rangesColumn.classList.remove('d-none');
            }
            if(this.buttonSortByDistance){
                if(haveLocation){
                    this.buttonSortByDistance.classList.remove('disabled');
                } else {
                    this.buttonSortByDistance.classList.add('disabled');
                }
            }
            if(this.buttonSortByPrice){
                this.buttonSortByPrice.classList.remove('d-none');
            }
        }

        initDropdownMenus(){

            const dropdownMenuOptions = {}
            this.restrictedToValuesDropdownMenuIDs.length = 0
            for(let i = 0; i < this.dropdownMenuParents.length; i++){
                const dropdownMenuParent = this.dropdownMenuParents[i];
                const dropdownToggle = dropdownMenuParent.querySelectorAll('.dropdown-toggle')[0] ?? null;
                const dropdownMenu =  dropdownMenuParent.querySelectorAll('.stay-on-page-dropdown-menu')[0];
                if(!dropdownToggle || !dropdownMenu){
                    this.dropdownMenuParents.splice(i, 1);
                    i --;
                    continue;
                }
                const cardToggle = core.toCamelCase(dropdownMenu.dataset.cardToggle ?? "");
                if(dropdownMenu.dataset.restrictedToValues){
                    this.restrictedToValuesDropdownMenuIDs.push(cardToggle);
                }

                const buttons = dropdownMenu.querySelectorAll('a');
                dropdownMenuOptions[cardToggle] = [];
                for(let button of buttons){
                    const filterValue = button.dataset.filterValue ?? "";
                    if(filterValue && !dropdownMenuOptions[cardToggle].includes(filterValue)){
                        dropdownMenuOptions[cardToggle].push(filterValue);
                    }
                    button.onclick = (event) => {
                        event.preventDefault();
                        this.applyDropdownValue(cardToggle, filterValue)
                        this.applyFilters();
                    }
                }
            }
            this.dropdownMenuOptions = dropdownMenuOptions;
            this.applyActiveToDropdownMenus();
        }

        initRanges(){
            const priceCooldownHandler = new CooldownHandler();

            this.maxPriceElement?.addEventListener("input", (event) =>
            {
                this.applyRangeValue("price")

                priceCooldownHandler.checkForCooldown(() => this.applyFilters())
            })
            const rentPerMonthCooldownHandler = new CooldownHandler();

            this.maxRentPerMonthElement?.addEventListener("input", (event) =>
            {
                this.applyRangeValue("rentPerMonth")

                rentPerMonthCooldownHandler.checkForCooldown(() => this.applyFilters())
            })
            const rentPerSquareFootCooldownHandler = new CooldownHandler();

            this.maxRentPerSquareFootElement?.addEventListener("input", (event) =>
            {
                this.applyRangeValue("rentPerSquareFoot")

                rentPerSquareFootCooldownHandler.checkForCooldown(() => this.applyFilters())
            })
            const sizeSquareFeetCooldownHandler = new CooldownHandler();

            this.maxSizeSquareFeetElement?.addEventListener("input", (event) =>
            {
                this.applyRangeValue("sizeSquareFeet")

                sizeSquareFeetCooldownHandler.checkForCooldown(() => this.applyFilters())
            })
        }

        initSizeSquareFeetSearch(){

            this.sizeSquareFeetSearchButton.addEventListener("click", (event) => {
                event.preventDefault();
                this.requestSizeSquareFeetSearch(this.sizeSquareFeetSearchText.value ?? "");
            });
            this.sizeSquareFeetSearchText.addEventListener("input", () => this.applySearchState());
            this.sizeSquareFeetSearchRadius.addEventListener("change", () => this.applySearchState());
            this.applySearchState();
        }


        initPropertyList(){
            const textSearch = this.sizeSquareFeetSearchText.value ?? "";
            if(textSearch){
                let searchRadiusValue = this.sizeSquareFeetSearchRadius.value ?? "";
                if(!searchRadiusValue){
                    const options =  this.sizeSquareFeetSearchRadius.querySelectorAll('option');
                    const lastOption = options[options.length - 1];
                    searchRadiusValue = lastOption ? lastOption.value : searchRadiusValue;
                    if(searchRadiusValue){
                        this.sizeSquareFeetSearchRadius.value = searchRadiusValue;
                        this.applySearchState();
                    }
                }
                this.requestSizeSquareFeetSearch(textSearch);
            } else if(!this.searchInputIsRequired){
                this.onLocationReceived();

                this.applySizeSquareFeetSearch();
                this.applyFilters(true);
                this.applyCurrentSort();
            }
        }

        initAdditionalButtons(){
            if(this.toggleFilters){
                this.toggleFilters.onclick = (event) => {
                    event.preventDefault();
                    this.searchContainer.classList.toggle('in_active');
                    if(this.searchContainer.classList.contains('in_active')){
                        this.toggleFilters.innerHTML = "Would you like to filter the results?"
                    } else {
                        this.toggleFilters.innerHTML = "Would you like to close the filters?"
                    }
                }
            }

            if(this.buttonSortByDistance){
                this.buttonSortByDistance.onclick = (event) => {
                    this.toggleSortByDistance();
                }
            }

            if(this.buttonSortByPrice){
                this.buttonSortByPrice.onclick = (event) => {
                    this.toggleSortByPrice();
                }
            }

            if(this.buttonSortByDate){
                this.buttonSortByDate.onclick = (event) => {
                    this.toggleSortByDate();
                }
            }
        }

        /**
         *
         * @returns {boolean|null}
         */
        getCurrentDistanceSort(){
            return this.sortOrder.indexOf("distance_ascending") >= 0 ? true : (this.sortOrder.indexOf("distance_descending") >= 0 ? false : null);
        }

        /**
         *
         * @returns {boolean|null}
         */
        getCurrentPriceSort(){
            return this.sortOrder.indexOf("price_ascending") >= 0 ? true : (this.sortOrder.indexOf("price_descending") >= 0 ? false : null);
        }

        /**
         *
         * @returns {boolean|null}
         */
        getCurrentDateSort(){
            return this.sortOrder.indexOf("date_descending") >= 0 ? true : (this.sortOrder.indexOf("date_ascending") >= 0 ? false : null);
        }

        toggleSortByDistance(){
            let currentIsAscending = this.getCurrentDistanceSort();
            let ascending = null;
            if(currentIsAscending === null){
                ascending = true;
            } else if(currentIsAscending === true){
                ascending = false;
            }
            this.setSortByDistance(ascending)
        }

        toggleSortByPrice(){
            let currentIsAscending = this.getCurrentPriceSort();
            let ascending = null;
            if(currentIsAscending === null){
                ascending = true;
            } else if(currentIsAscending === true){
                ascending = false;
            }
            this.setSortByPrice(ascending)
        }


        toggleSortByDate(){
            let currentIsDescending = this.getCurrentDateSort();
            let descending = null;
            if(currentIsDescending === null){
                descending = true;
            } else if(currentIsDescending === true){
                descending = false;
            }
            this.setSortByDate(descending)
        }

        /**
         *
         * @param ascending {boolean|null}
         * @param preventApply {boolean=}
         */
        setSortByDistance(ascending, preventApply){
            ascending = ascending ?? null;
            while(true){
                const index = this.sortOrder.indexOf("distance_ascending");
                if(index >= 0){
                    this.sortOrder.splice(index, 1);
                } else {
                    break;
                }
            }
            while(true){
                const index = this.sortOrder.indexOf("distance_descending");
                if(index >= 0){
                    this.sortOrder.splice(index, 1);
                } else {
                    break;
                }
            }
            if(ascending !== null){
                const toAdd = ascending ? "distance_ascending" : "distance_descending";
                this.sortOrder.unshift(toAdd);
            }
            if(!preventApply){
                this.applyCurrentSort();
            }
        }

        /**
         *
         * @param ascending {boolean|null}
         * @param preventApply {boolean=}
         */
        setSortByPrice(ascending, preventApply){
            ascending = ascending ?? null;
            while(true){
                const index = this.sortOrder.indexOf("price_ascending");
                if(index >= 0){
                    this.sortOrder.splice(index, 1);
                } else {
                    break;
                }
            }
            while(true){
                const index = this.sortOrder.indexOf("price_descending");
                if(index >= 0){
                    this.sortOrder.splice(index, 1);
                } else {
                    break;
                }
            }
            if(ascending !== null){
                const toAdd = ascending ? "price_ascending" : "price_descending";
                this.sortOrder.unshift(toAdd);
            }
            if(!preventApply){
                this.applyCurrentSort();
            }
        }


        /**
         *
         * @param descending {boolean|null}
         * @param preventApply {boolean=}
         */
        setSortByDate(descending, preventApply){
            descending = descending ?? null;
            while(true){
                const index = this.sortOrder.indexOf("date_descending");
                if(index >= 0){
                    this.sortOrder.splice(index, 1);
                } else {
                    break;
                }
            }
            while(true){
                const index = this.sortOrder.indexOf("date_ascending");
                if(index >= 0){
                    this.sortOrder.splice(index, 1);
                } else {
                    break;
                }
            }
            if(descending !== null){
                const toAdd = descending ? "date_descending" : "date_ascending";
                this.sortOrder.unshift(toAdd);
            }
            if(!preventApply){
                this.applyCurrentSort();
            }
        }

        applyCurrentSort()
        {
            let distanceIsAscending = this.getCurrentDistanceSort();
            let priceIsAscending = this.getCurrentPriceSort();
            let dateIsDescending = this.getCurrentDateSort();
            const canSortByDistance = !!this.buttonSortByDistance && !this.buttonSortByDistance.classList.contains('disabled') && !this.buttonSortByDistance.classList.contains('d-none');
            const canSortByPrice = !!this.buttonSortByPrice && !this.buttonSortByPrice.classList.contains('disabled') && !this.buttonSortByPrice.classList.contains('d-none');
            const canSortByDate = !!this.buttonSortByDate && !this.buttonSortByDate.classList.contains('disabled') && !this.buttonSortByDate.classList.contains('d-none');
            if(!canSortByDistance && (distanceIsAscending !== null)){
                this.setSortByDistance(null, true);
                distanceIsAscending = null;
            }
            if(!canSortByPrice && (priceIsAscending !== null)){
                this.setSortByPrice(null, true);
                priceIsAscending = null;
            }
            if(!canSortByDate && (dateIsDescending !== null)){
                this.setSortByDate(null, true);
                dateIsDescending = null;
            }
            if(!this.sortOrder.length){
                this.sortOrder.push("date_descending");
                dateIsDescending = true;
            }
            let possibleIcons = ["icon-ban", "icon-ascending", "icon-descending"];
            if(!!this.buttonSortByDistance)
            {
                for(let icon of possibleIcons){
                    this.buttonSortByDistance.classList.remove(icon);
                }
                let icon = "icon-ban";
                if(distanceIsAscending){
                    icon = "icon-ascending";
                } else if(distanceIsAscending === false){
                    icon = "icon-descending";
                }
                this.buttonSortByDistance.classList.add(icon);
            }
            if(!!this.buttonSortByPrice)
            {
                for(let icon of possibleIcons){
                    this.buttonSortByPrice.classList.remove(icon);
                }
                let icon = "icon-ban";
                if(priceIsAscending){
                    icon = "icon-ascending";
                } else if(priceIsAscending === false){
                    icon = "icon-descending";
                }
                this.buttonSortByPrice.classList.add(icon);
            }
            if(!!this.buttonSortByDate)
            {
                for(let icon of possibleIcons){
                    this.buttonSortByDate.classList.remove(icon);
                }
                let icon = "icon-ban";
                if(dateIsDescending){
                    icon = "icon-descending";
                } else if(dateIsDescending === false){
                    icon = "icon-ascending";
                }
                this.buttonSortByDate.classList.add(icon);
            }


            this.currentPropertyList.sort((a, b) => {
                if(a.active && !b.active){
                    return -1;
                }
                if(!a.active && b.active){
                    return 1;
                }
                for(let orderItem of this.sortOrder){
                    if(orderItem === "distance_ascending"){
                        if(a.distanceInMetres < b.distanceInMetres){
                            return -1;
                        }
                        if(a.distanceInMetres > b.distanceInMetres){
                            return 1;
                        }
                    } else if(orderItem === "distance_descending"){
                        if(a.distanceInMetres > b.distanceInMetres){
                            return -1;
                        }
                        if(a.distanceInMetres < b.distanceInMetres){
                            return 1;
                        }
                    }
                    if(orderItem === "price_ascending"){
                        let aPrice = a.price;
                        let bPrice = b.price;
                        if(this.currentPriceSortOption === "rentPerMonth"){
                            aPrice = a.rentPerMonthFrom;
                            bPrice = b.rentPerMonthFrom;
                        } else if(this.currentPriceSortOption === "rentPerSquareFoot"){
                            aPrice = a.rentPerSquareFootFrom;
                            bPrice = b.rentPerSquareFootFrom;
                        }
                        if(aPrice && !bPrice){
                            return -1;
                        }
                        if(!aPrice && bPrice){
                            return 1;
                        }
                        if(aPrice < bPrice){
                            return -1;
                        }
                        if(aPrice > bPrice){
                            return 1;
                        }
                    } else if(orderItem === "price_descending"){
                        let aPrice = a.price;
                        let bPrice = b.price;
                        if(this.currentPriceSortOption === "rentPerMonth"){
                            aPrice = a.rentPerMonthTo;
                            bPrice = b.rentPerMonthTo;
                        } else if(this.currentPriceSortOption === "rentPerSquareFoot"){
                            aPrice = a.rentPerSquareFootTo;
                            bPrice = b.rentPerSquareFootTo;
                        }
                        if(aPrice > bPrice){
                            return -1;
                        }
                        if(aPrice < bPrice){
                            return 1;
                        }
                    }
                    if(orderItem === "date_ascending"){
                        const aTime = a.postDate?.getTime() ?? Number.MAX_SAFE_INTEGER;
                        const bTime = b.postDate?.getTime() ?? Number.MAX_SAFE_INTEGER;
                        if(aTime < bTime){
                            return -1;
                        }
                        if(aTime > bTime){
                            return 1;
                        }
                    } else if(orderItem === "date_descending"){
                        const aTime = a.postDate?.getTime() ?? Number.MAX_SAFE_INTEGER;
                        const bTime = b.postDate?.getTime() ?? Number.MAX_SAFE_INTEGER;
                        if(aTime > bTime){
                            return -1;
                        }
                        if(aTime < bTime){
                            return 1;
                        }
                    }
                }
                const aIndex = this.allPropertyList.indexOf(a);
                const bIndex = this.allPropertyList.indexOf(b);
                return aIndex <= bIndex ? -1 : 1;
            });

            for(let property of this.allPropertyList) {
                property.card.remove();
            }
            for(let property of this.currentPropertyList){
                property.parentElement.appendChild(property.card);
            }
        }

        initMapButtons(){
            if(!this.map){
                return;
            }

            if(this.buttonMapPrevious){
                this.buttonMapPrevious.onclick = (event) => {
                    this.map.cluster?.showPreviousClusterMarker()
                }
            }
            if(this.buttonMapNext){
                this.buttonMapNext.onclick = (event) => {
                    this.map.cluster?.showNextClusterMarker()
                }
            }
        }


        initPriceSortOptions(){
            const buttons = this.rentSortPreferenceContainer.querySelectorAll('input[name="rent_sort_preference"]')

            for (let button of buttons) {
                button.onchange = () => {
                    this.applyFilters();
                }
            }
        }

        determineCurrentPriceSortOption(){

            let currentPriceSortOption = "price";

            let isToLet = false;
            if(this.priceSortOptions.includes("rentPerMonth") || this.priceSortOptions.includes("rentPerSquareFoot")){
                for(let dropdownMenu of this.dropdownMenus){
                    if(dropdownMenu.dataset.cardToggle === "sale_let_status"){
                        if(dropdownMenu.dataset.currentValue === "to_let"){
                            isToLet = true;
                            break;
                        }
                    }
                    if(dropdownMenu.dataset.cardToggle === "availability_status"){
                        if(dropdownMenu.dataset.currentValue === "let"){
                            isToLet = true;
                            break;
                        }
                    }
                }
            }
            if(isToLet){
                if(!this.priceSortOptions.includes("rentPerSquareFoot")){
                    currentPriceSortOption = "rentPerMonth";
                } else if(!this.priceSortOptions.includes("rentPerMonth")){
                    currentPriceSortOption = "rentPerSquareFoot";
                } else {
                    if(this.rentSortPreferenceContainer){
                        const rentValue = this.rentSortPreferenceContainer.querySelector('input[name="rent_sort_preference"]:checked')?.value;
                        currentPriceSortOption = rentValue !== "per_square_foot" ? "rentPerMonth" : "rentPerSquareFoot";
                    }
                }
            }
            this.currentPriceSortOption = currentPriceSortOption;
        }

        applySearchState(){
            const textSearch = this.sizeSquareFeetSearchText.value ?? "";
            const searchRadiusValue = this.sizeSquareFeetSearchRadius.value ?? "";
            if(!textSearch || !searchRadiusValue){
                this.sizeSquareFeetSearchButton.classList.add('disabled');
            } else {
                this.sizeSquareFeetSearchButton.classList.remove('disabled');
            }

            core.updateQueryStringParam('text_search', textSearch)
            core.updateQueryStringParam('search_radius', searchRadiusValue)
        }

        /**
         *
         * @param cardToggle {string}
         * @param value {string|null=}
         */
        applyDropdownValue(cardToggle, value){
            value = value ?? "";

            for(let dropdownMenuParent of this.dropdownMenuParents){
                const dropdownToggle = dropdownMenuParent.querySelectorAll('.dropdown-toggle')[0];
                const dropdownMenu = dropdownMenuParent.querySelectorAll('.stay-on-page-dropdown-menu')[0];
                const thisCardToggle = core.toCamelCase(dropdownMenu.dataset.cardToggle ?? "");
                if(thisCardToggle === cardToggle){
                    let text = dropdownToggle.dataset.defaultText ?? "";
                    if(value){
                        const button = Array.from(dropdownMenu.querySelectorAll('a')).filter(button => button.dataset.filterValue === value)[0] ?? null;
                        if(button){
                            text = button.textContent;
                        } else {
                            value = "";
                        }
                    }
                    dropdownToggle.innerHTML = text;
                    dropdownMenu.dataset.currentValue = value;
                    break;
                }
            }
            this.applyActiveToDropdownMenus();

        }

        applyActiveToDropdownMenus(){
            for(let dropdownMenuParent of this.dropdownMenuParents){
                const dropdownMenu = dropdownMenuParent.querySelectorAll('.stay-on-page-dropdown-menu')[0];
                const currentValue = dropdownMenu.dataset.currentValue ?? "";
                const buttons = dropdownMenu.querySelectorAll('a');
                let is_active_now = false;
                for(let button of buttons){
                    const filterValue = button.dataset.filterValue ?? "";
                    if(currentValue && currentValue != '' && filterValue === currentValue)
                    {
                        is_active_now = true;
                    } 
                }
                if (is_active_now)
                {
                    dropdownMenu.parentNode.classList.add('active');
                }
                else 
                {
                    dropdownMenu.parentNode.classList.remove('active');
                }

            }
        }

        /**
         *
         * @param type {string}
         */
        applyRangeValue (type) {
            /** @type {HTMLInputElement|null} */
            let sliderElement = null;
            /** @type {HTMLInputElement|null} */
            let displayElement = null;
            let options = {};
            if(type === "price" && !!this.maxPriceElement){
                sliderElement = this.maxPriceElement;
                displayElement = this.maxPriceDisplayElement;
                options = {style:"currency", currency:"GBP", minimumFractionDigits: 0, maximumFractionDigits: 0};
            } else if(type === "rentPerMonth" && !!this.maxRentPerMonthElement){
                sliderElement = this.maxRentPerMonthElement;
                displayElement = this.maxRentPerMonthDisplayElement;
                options = {style:"currency", currency:"GBP", minimumFractionDigits: 0, maximumFractionDigits: 0};
            } else if(type === "rentPerSquareFoot" && !!this.maxRentPerSquareFootElement){
                sliderElement = this.maxRentPerSquareFootElement;
                displayElement = this.maxRentPerSquareFootDisplayElement;
                options = {style:"currency", currency:"GBP", minimumFractionDigits: 0, maximumFractionDigits: 0};
            } else if(type === "sizeSquareFeet" && !!this.maxSizeSquareFeetElement){
                sliderElement = this.maxSizeSquareFeetElement;
                displayElement = this.maxSizeSquareFeetDisplayElement;
                options = {minimumFractionDigits: 0, maximumFractionDigits: 0};
            } else {
                return
            }

            const sliderValue = parseInt(sliderElement.value ?? 0);

            displayElement.textContent = sliderValue.toLocaleString("en-US", options);

            //const progress = sliderElement.max ? (sliderValue / parseInt(sliderElement.max)) * 100 : 100;

            sliderElement.style.background = 'linear-gradient(to right, #f50 ${progress}%, #ccc ${progress}%)';

        }

        requestSizeSquareFeetSearch(searchTextValue){

            const applyLocation = (location) => {
                const latitude = parseFloat(location?.latitude ?? "0");
                const longitude = parseFloat(location?.longitude ?? "0");
                if(!(latitude || longitude)){
                    this.onLocationError("Invalid location");
                    return false;
                }
                if(this.fromLocationMessage && this.fromLocationValue){
                    this.fromLocationMessage.classList.remove('d-none');
                    this.fromLocationValue.innerHTML = core.ucWords(core.stripSpace(searchTextValue).trim());
                }
                this.onLocationReceived(true);
                this.setSortByDistance(true)
                this.latitude = latitude;
                this.longitude = longitude;
                if(this.resultsForLocation){
                    let locationName = location.address?.display_name;
                    locationName = locationName ? locationName : location.title
                    locationName = locationName ? locationName : searchTextValue;
                    locationName = locationName.replace(', United Kingdom','');
                    locationName = locationName.replace(', Northern Ireland','');
                    locationName = locationName.replace('Belfast, Belfast City District','Belfast');
                    locationName = locationName.replace(' / Tuaisceart Éireann','');
                    this.resultsForLocation.textContent = locationName;
                }
                this.applySizeSquareFeetSearch(searchTextValue);
                this.applyFilters(true);
                this.applyCurrentSort();
                return true;
            }

            searchTextValue = core.stripSpace(searchTextValue);
            const searchKey = searchTextValue.toLowerCase();
            const previousSearch = this.previousSearches[searchKey] ?? null;
            if(previousSearch){
                this.animateListingsGroup(() =>{
                    this.listingsErrorContainer.classList.add('d-none');
                    this.listingsErrorText.textContent = "";
                    applyLocation(previousSearch);
                })
                return;
            }

            this.onLocationRequested();

            request.fetchData("/wp-json/locate/coordinates", null, {
                location: searchTextValue
            }).then(response => {
                this.animateListingsGroup(() =>{
                    const values = response?.data?.values ?? null;
                    const location = Array.isArray(values) ? (values[0] ?? {}) : {};
                    const valid = applyLocation(location);
                    if(valid){
                        this.previousSearches[searchKey] = location;
                    }
                }, true)
            }).catch(error => {
                this.onLocationError(error.message ?? "Unknown error occurred. [1]");
            })
        }

        /**
         *
         * @param searchTextValue {string=}
         */
        applySizeSquareFeetSearch(searchTextValue){
            const searchRadiusValue = this.sizeSquareFeetSearchRadius.value ?? "";
            const searchRadiusMetres = searchRadiusValue ? core.milesToKilometres(parseFloat(searchRadiusValue)) * 1000 : 0;

            for(let property of this.allPropertyList) {
                property.active = false;
            }
            this.currentPropertyList = this.allPropertyList.slice();

            for(let i = 0; i < this.currentPropertyList.length; i++) {
                const property = this.currentPropertyList[i];
                property.distanceInMetres = (this.latitude || this.longitude) && (property.latitude || property.longitude) ? core.getDistanceInMetresBetween(this.latitude, this.longitude, property.latitude, property.longitude) : Number.MAX_SAFE_INTEGER;
                if(searchRadiusMetres && (property.distanceInMetres > searchRadiusMetres)){
                    this.currentPropertyList.splice(i, 1);
                    i --;
                    continue;
                }
                for(let key in this.dropdownMenuOptions){

                    if(!this.restrictedToValuesDropdownMenuIDs.includes(key)){
                        continue;
                    }
                    const propertyValue = property[key] ?? [];
                    const propertyValues = Array.isArray(propertyValue) ? propertyValue : [propertyValue];
                    let optionFound = false;
                    for(let value of propertyValues){
                        if((this.dropdownMenuOptions[key] ?? []).includes(value)){
                            optionFound = true;
                            break;
                        }
                    }
                    if(!optionFound){
                        this.currentPropertyList.splice(i, 1);
                        i --;
                        break;
                    }
                }
            }

            this.currentPropertyList.sort((a, b) => {
                if(a.distanceInMetres < b.distanceInMetres){
                    return -1;
                }
                if(a.distanceInMetres > b.distanceInMetres){
                    return 1;
                }
                const aIndex = this.allPropertyList.indexOf(a);
                const bIndex = this.allPropertyList.indexOf(b);
                return aIndex <= bIndex ? -1 : 1;
            });

            for(let property of this.currentPropertyList){
                const propertyDistanceElement = property.card.querySelectorAll('.property-distance')[0];
                const distanceTextElement = propertyDistanceElement?.querySelectorAll('.distance-text')[0] ?? null;
                const markerPropertyDistanceElement = property.mapMarker?.querySelectorAll(".property-distance")[0] ?? null;
                const markerDistanceTextElement = markerPropertyDistanceElement?.querySelectorAll('.distance-text')[0] ?? null;
                if(distanceTextElement){
                    let distanceText = "";
                    if(property.distanceInMetres < Number.MAX_SAFE_INTEGER){
                        const distanceInMiles = core.kilometresToMiles(property.distanceInMetres / 1000);
                        if(distanceInMiles >= 1) {
                            distanceText = (Math.round(distanceInMiles * 10) / 10).toLocaleString() + " miles";
                        } else if(distanceInMiles >= 0.5){
                            distanceText = "< 1 mile";
                        } else {
                            distanceText = "< 0.5 miles";
                        }
                        propertyDistanceElement.classList.remove("d-none")
                        distanceTextElement.textContent = distanceText;
                        if(markerDistanceTextElement){
                            markerPropertyDistanceElement.classList.remove("d-none")
                            markerDistanceTextElement.textContent = distanceText;
                        }
                    } else {
                        propertyDistanceElement.classList.add("d-none")
                        if(markerPropertyDistanceElement){

                            markerPropertyDistanceElement.classList.add("d-none")
                        }
                    }
                }
                /** @type {HTMLAnchorElement|null} */
                const stretchedLink = property.card.querySelectorAll('.stretched-link')[0] ?? null;
                if(stretchedLink?.href){
                    if(this.latitude || this.longitude){
                        stretchedLink.href = core.updateDefinedQueryStringParam(stretchedLink.href, "latitude", this.latitude)
                        stretchedLink.href = core.updateDefinedQueryStringParam(stretchedLink.href, "longitude", this.longitude)
                        stretchedLink.href = core.updateDefinedQueryStringParam(stretchedLink.href, "text_search", searchTextValue)
                    }
                }
                /** @type {HTMLAnchorElement|null} */
                const markerStretchedLink = property.mapMarker?.querySelectorAll('.stretched-link')[0] ?? null;
                if(markerStretchedLink?.href){
                    if(this.latitude || this.longitude){
                        markerStretchedLink.href = core.updateDefinedQueryStringParam(stretchedLink.href, "latitude", this.latitude)
                        markerStretchedLink.href = core.updateDefinedQueryStringParam(stretchedLink.href, "longitude", this.longitude)
                        markerStretchedLink.href = core.updateDefinedQueryStringParam(stretchedLink.href, "text_search", searchTextValue)
                    }
                }

                property.active = true;
            }
        }

        applyActiveUI(){


            const activeDropdownMenuOptions = {};
            for(let key in this.dropdownMenuOptions){
                activeDropdownMenuOptions[key] = [];
            }

            const haveUnknownDropdownMenuOptionsFor = {};

            for(let property of this.currentPropertyList) {

                for (let key in activeDropdownMenuOptions) {
                    const propertyValue = property[key] ?? [];
                    const propertyValues = Array.isArray(propertyValue) ? propertyValue : [propertyValue];
                    let optionFound = false;
                    for (let value of propertyValues) {
                        if ((this.dropdownMenuOptions[key] ?? []).includes(value)) {
                            optionFound = true;
                            if (!activeDropdownMenuOptions[key].includes(value)) {
                                activeDropdownMenuOptions[key].push(value);
                            }
                        }
                    }
                    if (!optionFound) {
                        haveUnknownDropdownMenuOptionsFor[key] = true;
                    }
                }
            }

            let minPrice = null;
            let maxPrice = 0;
            let minRentPerMonth = null;
            let maxRentPerMonth = 0;
            let minRentPerSquareFoot = null;
            let maxRentPerSquareFoot = 0;
            let minSizeSquareFeet = null;
            let maxSizeSquareFeet = 0;

            for(let property of this.currentPropertyList){

                const price = property.price ?? 0;
                maxPrice = Math.max(price, maxPrice);
                minPrice = minPrice === null ? price : Math.min(price, minPrice);

                const rentPerMonth = property.rentPerMonthFrom ?? 0;
                maxRentPerMonth = Math.max(rentPerMonth, maxRentPerMonth);
                minRentPerMonth = minRentPerMonth === null ? rentPerMonth : Math.min(rentPerMonth, minRentPerMonth);

                const rentPerSquareFoot = property.rentPerSquareFootFrom ?? 0;
                maxRentPerSquareFoot = Math.max(rentPerSquareFoot, maxRentPerSquareFoot);
                minRentPerSquareFoot = minRentPerSquareFoot === null ? rentPerSquareFoot : Math.min(rentPerSquareFoot, minRentPerSquareFoot);

                const sizeSquareFeet = property.sizeSquareFeetFrom ?? 0;
                maxSizeSquareFeet = Math.max(sizeSquareFeet, maxSizeSquareFeet);
                minSizeSquareFeet = minSizeSquareFeet === null ? sizeSquareFeet : Math.min(sizeSquareFeet, minSizeSquareFeet);
            }

            minPrice = minPrice ?? 0;
            minRentPerMonth = minRentPerMonth ?? 0;
            minRentPerSquareFoot = minRentPerSquareFoot ?? 0;
            minSizeSquareFeet = minSizeSquareFeet ?? 0;

            for(let key in activeDropdownMenuOptions){
                const options = activeDropdownMenuOptions[key];

                options.sort((a, b) => {
                    const aIndex = (this.dropdownMenuOptions[key] ?? []).indexOf(a);
                    const bIndex = (this.dropdownMenuOptions[key] ?? []).indexOf(b);
                    return aIndex <= bIndex ? -1 : 1;
                });
            }

            let haveAnyOptions = false;
            for(let dropdownMenuParent of this.dropdownMenuParents){
                const dropdownMenu = dropdownMenuParent.querySelectorAll('.stay-on-page-dropdown-menu')[0];
                const cardToggle = core.toCamelCase(dropdownMenu.dataset.cardToggle ?? "");
                const activeOptions = activeDropdownMenuOptions[cardToggle] ?? null
                if(!activeOptions){
                    continue;
                }
                if(dropdownMenu.dataset.currentValue && !activeOptions.includes(dropdownMenu.dataset.currentValue)){
                    this.applyDropdownValue(cardToggle, null);
                }
                let optionCount = activeOptions.length;
                if(!!haveUnknownDropdownMenuOptionsFor[cardToggle]){
                    optionCount ++;
                }
                const buttons = dropdownMenu.querySelectorAll('a');

                for (let button of buttons) {
                    const filterValue = button.dataset.filterValue ?? "";
                    const alwaysHidden = !!parseInt(button.dataset.alwaysHidden ?? "0");
                    if(filterValue && !activeOptions.includes(filterValue)){
                        button.classList.add("d-none");
                    } else {
                        if(alwaysHidden){
                            optionCount --;
                            button.classList.add("d-none");
                        } else {
                            button.classList.remove("d-none");
                        }
                    }
                }
                if(optionCount < 2){
                    dropdownMenuParent.classList.add("d-none");
                } else {
                    haveAnyOptions = true;
                    dropdownMenuParent.classList.remove("d-none");
                }
            }
            if(this.filtersColumn){
                if(!haveAnyOptions){
                    this.filtersColumn.classList.add('d-none');
                } else {
                    this.filtersColumn.classList.remove('d-none');
                }
            }


            /**
             *
             * @param value {int}
             * @param step {int}
             * @param isFloor {boolean=}
             * @returns {number}
             */
            const steppedValue = (value, step, isFloor) => {
                value = value / step;
                if(!isFloor){
                    value = Math.ceil(value);
                } else {
                    value = Math.floor(value);
                }
                return value * step;
            }

            if(!!this.maxPriceElement){
                let priceStep = parseInt(this.maxPriceElement?.step ?? 0);
                priceStep = priceStep > 0 ? priceStep : 1;

                const previousMin = steppedValue(parseInt(this.maxPriceElement.min ?? 0), priceStep);
                const previousMax = steppedValue(parseInt(this.maxPriceElement.max ?? 0), priceStep);
                minPrice = steppedValue(minPrice, priceStep);
                maxPrice = steppedValue(maxPrice, priceStep);

                let value = steppedValue(parseInt(this.maxPriceElement.value ?? 0), priceStep);
                value = value === previousMax ? maxPrice : (value === previousMin ? minPrice : value);
                value = Math.min(maxPrice, Math.max(minPrice, value));

                this.maxPriceElement.min = minPrice.toString();
                this.maxPriceElement.max = maxPrice.toString();
                this.maxPriceElement.value = value.toString();
                this.maxPriceElement.defaultValue = this.maxPriceElement.value;
                this.applyRangeValue("price");
            }

            if(!!this.maxRentPerMonthElement){
                let rentPerMonthStep = parseInt(this.maxRentPerMonthElement?.step ?? 0);
                rentPerMonthStep = rentPerMonthStep > 0 ? rentPerMonthStep : 1;

                const previousMin = steppedValue(parseInt(this.maxRentPerMonthElement.min ?? 0), rentPerMonthStep);
                const previousMax = steppedValue(parseInt(this.maxRentPerMonthElement.max ?? 0), rentPerMonthStep);
                minRentPerMonth = steppedValue(minRentPerMonth, rentPerMonthStep);
                maxRentPerMonth = steppedValue(maxRentPerMonth, rentPerMonthStep);

                let value = steppedValue(parseInt(this.maxRentPerMonthElement.value ?? 0), rentPerMonthStep);
                value = value === previousMax ? maxPrice : (value === previousMin ? minPrice : value);
                value = Math.min(maxRentPerMonth, Math.max(minRentPerMonth, value));

                this.maxRentPerMonthElement.min = minRentPerMonth.toString();
                this.maxRentPerMonthElement.max = maxRentPerMonth.toString();
                this.maxRentPerMonthElement.value = value.toString();
                this.maxRentPerMonthElement.defaultValue = this.maxRentPerMonthElement.value;
                this.applyRangeValue("rentPerMonth");
            }

            if(!!this.maxRentPerSquareFootElement){
                let rentPerSquareFootStep = parseInt(this.maxRentPerSquareFootElement?.step ?? 0);
                rentPerSquareFootStep = rentPerSquareFootStep > 0 ? rentPerSquareFootStep : 1;


                const previousMin = steppedValue(parseInt(this.maxRentPerSquareFootElement.min ?? 0), rentPerSquareFootStep);
                const previousMax = steppedValue(parseInt(this.maxRentPerSquareFootElement.max ?? 0), rentPerSquareFootStep);

                minRentPerSquareFoot = steppedValue(minRentPerSquareFoot, rentPerSquareFootStep);
                maxRentPerSquareFoot = steppedValue(maxRentPerSquareFoot, rentPerSquareFootStep);

                let value = steppedValue(parseInt(this.maxRentPerSquareFootElement.value ?? 0), rentPerSquareFootStep);
                value = value === previousMax ? maxPrice : (value === previousMin ? minPrice : value);
                value = Math.min(maxRentPerSquareFoot, Math.max(minRentPerSquareFoot, value));

                this.maxRentPerSquareFootElement.min = minRentPerSquareFoot.toString();
                this.maxRentPerSquareFootElement.max = maxRentPerSquareFoot.toString();
                this.maxRentPerSquareFootElement.value = value.toString();
                this.maxRentPerSquareFootElement.defaultValue = this.maxRentPerSquareFootElement.value;
                this.applyRangeValue("rentPerSquareFoot");
            }

            if(!!this.maxSizeSquareFeetElement){
                let sizeSquareFeetStep = parseInt(this.maxSizeSquareFeetElement.step ?? 0);
                sizeSquareFeetStep = sizeSquareFeetStep > 0 ? sizeSquareFeetStep : 1;


                const previousMin = steppedValue(parseInt(this.maxSizeSquareFeetElement.min), sizeSquareFeetStep);
                const previousMax = steppedValue(parseInt(this.maxSizeSquareFeetElement.max), sizeSquareFeetStep);

                minSizeSquareFeet = steppedValue(minSizeSquareFeet, sizeSquareFeetStep);
                maxSizeSquareFeet = steppedValue(maxSizeSquareFeet, sizeSquareFeetStep);

                let value = steppedValue(parseInt(this.maxSizeSquareFeetElement.value ?? 0), sizeSquareFeetStep);
                value = value === previousMax ? maxSizeSquareFeet : (value === previousMin ? minPrice : value);
                value = Math.min(maxSizeSquareFeet, Math.max(minSizeSquareFeet, value));

                this.maxSizeSquareFeetElement.min = minSizeSquareFeet.toString();
                this.maxSizeSquareFeetElement.max = maxSizeSquareFeet.toString();

                this.maxSizeSquareFeetElement.value = value.toString();
                this.maxSizeSquareFeetElement.defaultValue = this.maxSizeSquareFeetElement.value;

                this.applyRangeValue("sizeSquareFeet");
            }

            const canPrice = (this.currentPriceSortOption === "price") && !!maxPrice && !!this.maxPriceElement;
            const canRentPerMonth = (this.currentPriceSortOption === "rentPerMonth") && !!maxRentPerMonth && !!this.maxRentPerMonthElement;
            const canRentPerSquareFoot = (this.currentPriceSortOption === "rentPerSquareFoot") && !!maxRentPerSquareFoot && !!this.maxRentPerSquareFootElement;
            const canSizeSquareFeet = !!maxSizeSquareFeet && !!this.maxSizeSquareFeetElement;

            if(this.rangesColumn){
                if(!canPrice && !canRentPerMonth && !canRentPerSquareFoot && !canSizeSquareFeet){
                    this.rangesColumn.classList.add('d-none');
                } else {
                    this.rangesColumn.classList.remove('d-none');
                }
            }
            if(this.buttonSortByPrice){
                if(!canPrice && !canRentPerMonth && !canRentPerSquareFoot){
                    this.buttonSortByPrice.classList.add('disabled');
                } else {
                    this.buttonSortByPrice.classList.remove('disabled');
                }
            }

            if(this.rentSortPreferenceContainer){
                if(this.currentPriceSortOption === "price" || !this.priceSortOptions.includes("rentPerMonth") || !this.priceSortOptions.includes("rentPerSquareFoot")){

                    this.rentSortPreferenceContainer.classList.add("d-none");
                } else {
                    const selectedValue = this.currentPriceSortOption !== "rentPerSquareFoot" ? "per_month" : "per_square_foot";
                    if(this.rentSortPreferenceContainer){
                    }
                    this.rentSortPreferenceContainer.classList.remove("d-none");
                    const selectedElement = this.rentSortPreferenceContainer.querySelector('input[name="rent_sort_preference"][value="'+selectedValue+'"]');
                    if(selectedElement){
                        selectedElement.checked = true;
                    }
                }
            }
            if(this.maxPriceContainerElement){
                if(this.currentPriceSortOption === "price"){
                    this.maxPriceContainerElement.classList.remove("d-none");
                } else {
                    this.maxPriceContainerElement.classList.add("d-none");
                }
            }
            if(this.maxRentPerMonthContainerElement){
                if(this.currentPriceSortOption === "rentPerMonth"){
                    this.maxRentPerMonthContainerElement.classList.remove("d-none");
                } else {
                    this.maxRentPerMonthContainerElement.classList.add("d-none");
                }
            }
            if(this.maxRentPerSquareFootContainerElement){
                if(this.currentPriceSortOption === "rentPerSquareFoot"){
                    this.maxRentPerSquareFootContainerElement.classList.remove("d-none");
                } else {
                    this.maxRentPerSquareFootContainerElement.classList.add("d-none");
                }
            }
        }

        /**
         *
         * @param noFade {boolean=}
         */
        applyFilters(noFade)
        {
            this.determineCurrentPriceSortOption();
            this.applyActiveUI();

            let activeCount = 0;
            let willHide = false;


            for(let property of this.currentPropertyList){

                let active = true;
                for(let dropdownMenu of this.dropdownMenus){
                    const cardToggle = core.toCamelCase(dropdownMenu.dataset.cardToggle ?? "");
                    const currentValue = dropdownMenu.dataset.currentValue ?? "";
                    if(currentValue){
                        const cardValue = property[cardToggle] ?? "";
                        if(Array.isArray(cardValue)){
                            if(!cardValue.includes(currentValue)){
                                active = false;
                                break;
                            }
                        } else {
                            if(cardValue !== currentValue){
                                active = false;
                                break;
                            }
                        }
                    }
                }
                if(active && this.maxPriceElement && (this.currentPriceSortOption === "price")){
                    const maxPriceValue = parseInt(this.maxPriceElement.value ?? 0);

                    if(maxPriceValue < parseInt(this.maxPriceElement.max)){
                        if (property.price > maxPriceValue)
                        {
                            active = false;
                        }
                    }
                }
                if(active && this.maxRentPerMonthElement && (this.currentPriceSortOption === "rentPerMonth")){
                    const maxRentPerMonthValue = parseInt(this.maxRentPerMonthElement.value ?? 0);

                    if(maxRentPerMonthValue < parseInt(this.maxRentPerMonthElement.max)){
                        if (property.rentPerMonthFrom > maxRentPerMonthValue)
                        {
                            active = false;
                        }
                    }
                }
                if(active && this.maxRentPerSquareFootElement && (this.currentPriceSortOption === "rentPerSquareFoot")){
                    const maxRentPerSquareFootValue = parseInt(this.maxRentPerSquareFootElement.value ?? 0);

                    if(maxRentPerSquareFootValue < parseInt(this.maxRentPerSquareFootElement.max)){
                        if (property.rentPerSquareFootFrom > maxRentPerSquareFootValue)
                        {
                            active = false;
                        }
                    }

                }
                if(active && this.maxSizeSquareFeetElement){
                    const maxSizeSquareFeetValue = parseInt(this.maxSizeSquareFeetElement.value ?? 0);
                    if(maxSizeSquareFeetValue < parseInt(this.maxSizeSquareFeetElement.max)){
                        if (!property.sizeSquareFeetFrom || (property.sizeSquareFeetFrom > maxSizeSquareFeetValue))
                        {
                            active = false;
                        }
                    }
                }

                if(active){
                    activeCount ++;
                } else {
                    if(property.active){
                        willHide = true;
                    }
                }
                property.active = active;
            }

            const showCurrentCards = () => {

                const activePostIDs = [];
                for(let property of this.currentPropertyList){
                    if(property.active){
                        property.card.classList.remove("d-none");
                        activePostIDs.push(property.postID);
                    } else {
                        property.card.classList.add("d-none");
                    }
                }
                if(this.map){
                    this.map.cluster?.showDefinedClusterMarkers(activePostIDs);
                    const canCycleClusterMarkers = this.map.cluster?.canCycleClusterMarkers() ?? false;
                    if(!canCycleClusterMarkers){
                        this.buttonMapPrevious?.classList.add("disabled");
                        this.buttonMapNext?.classList.add("disabled");
                    } else {
                        this.buttonMapPrevious?.classList.remove("disabled");
                        this.buttonMapNext?.classList.remove("disabled");
                    }
                }
                if(this.pageCounterResults){
                    this.pageCounterResults.textContent = activeCount + " listing" + ( (activeCount !== 1) ? "s" : ''  );
                }
                if(!!activeCount){
                    if(this.noResults){
                        this.noResults.classList.remove("active");
                    }
                } else {
                    if(this.noResults){
                        this.noResults.classList.remove("active");
                    }
                }
                this.applyCurrentSort();
            }

            if(!noFade){
                this.animateListingsGroup(showCurrentCards, !willHide, !activeCount);
            } else {
                showCurrentCards();
            }
        }

        /**
         *
         * @param midPointCallback {() => void}
         * @param immediateOut {boolean=}
         * @param immediateIn {boolean=}
         */
        animateListingsGroup(midPointCallback, immediateOut, immediateIn){

            core.fadeOut(this.listingsGroup, !immediateOut ? 300 : 0, true, () => {
                midPointCallback();
                core.fadeIn(this.listingsGroup, !immediateIn ? 300 : 0);
            })
        }

    }

    const filtersBoxes = document.querySelectorAll('.filters-box');
    /** @type {HTMLElement[]} */
    const filterViewSections = [];
    window.filterViewControllers = [];

    for(let filtersBox of filtersBoxes){
        const section = filtersBox.closest('section');
        if(section && !filterViewSections.includes(section)){
            filterViewSections.push(section);
        }
    }

    const initializeReadyControllers = () => {
        let haveAll = true;
        for(let section of filterViewSections){
            if(section.dataset.isFilterInitialized){
                continue;
            }
            const map = section.querySelectorAll('.osm-map.populate')[0] ?? null;
            if(!map || (map.id && OSM.Maps[map.id]?.isMapReady)){
                section.dataset.isFilterInitialized = "1";
                window.filterViewControllers.push(new FilterViewController(section));
            } else {
                haveAll = false;
            }
        }
        if(haveAll){
            document.removeEventListener("site.osm-ready", initializeReadyControllers);
        }
    }
    document.addEventListener("site.osm-ready", initializeReadyControllers);

    initializeReadyControllers();


});